import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { useOpenSidePanel } from "../SidePanel";
import { GuestlistConfigSidePanelDetails } from "./GuestlistConfigSidePanelDetails";
import { SidePanelDeleteEntryButton } from "../SidePanelDeleteEntryButton";

export const useOpenGuestlistConfigSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openGuestlistConfigSidePanel = React.useCallback((guestlistId: number, onDelete: () => void) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Guestlist.GetSidePanelData(guestlistId)}
      apiKey="guestlistConfiguration"
      entityId={guestlistId}
      title={RESX.Guestlist.GuestlistConfiguration}
      footerContent={<>
        <SidePanelDeleteEntryButton
          apiCall={() => window.CoreApi.Guestlist.DeleteGuestlistConfiguration({ guestlistId }, { toastOnError: true })}
          onSuccess={() => onDelete()}
        />
      </>}
      skipSidePanelBase
    >
      {(data) => <GuestlistConfigSidePanelDetails
        data={data}
      />}
    </DetailSidePanel>, `guestlist-config-side-${guestlistId}`, "medium");
  }, [openSidePanel]);

  return openGuestlistConfigSidePanel;
}